import { render } from "./Rated.vue?vue&type=template&id=bf76a394"
import script from "./Rated.vue?vue&type=script&lang=js"
export * from "./Rated.vue?vue&type=script&lang=js"

import "./Rated.vue?vue&type=style&index=0&id=bf76a394&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip,QChip});
